import { render, staticRenderFns } from "./DashboardAcompanhamento.vue?vue&type=template&id=2950bb69&scoped=true&lang=html&"
import script from "./DashboardAcompanhamento.vue?vue&type=script&lang=js&"
export * from "./DashboardAcompanhamento.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAcompanhamento.vue?vue&type=style&index=0&id=2950bb69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950bb69",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/acompanhamento/DashboardAcompanhamento.vue
// module id = 1266
// module chunks = 28